/* eslint-disable react/prop-types */
import React from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';

import { TextField } from '@material-ui/core';
import { format } from 'date-fns';

import { DataTypeProvider } from '@devexpress/dx-react-grid';
import ImageFullScreenDialog from '../../../shared/dialog/ImageFullScreenDialog';
import {
  getQualificationStatusColor,
  parseQualificationDate,
  statusColorStyles,
  statusTextClasses
} from '../helper/helper';

// Starts inline editing on focus and displays validation errors for qualification fields.
export const QualificationFocusableCell = ({
  onClick,
  validationStatus = {},
  setValidationStatus = () => {},
  ...restProps
}) => {
  const { row, column } = restProps;
  const fieldStatus = validationStatus[row?.id]?.[column?.name];
  const isInvalid = fieldStatus?.isValid === false;

  const handleFocus = (event) => {
    // Focus bubbles from the lookup <select>. Starting editing again at that point
    // interrupts the select's change/blur commit lifecycle.
    if (event.currentTarget !== event.target) return;

    if (isInvalid) {
      setValidationStatus((previous) => ({
        ...previous,
        [row?.id]: {
          ...previous[row?.id],
          [column?.name]: undefined
        }
      }));
    }
    onClick?.(event);
  };

  if (column?.name === 'qualificationUrl') {
    return (
      <Table.Cell {...restProps}>
        <ImageFullScreenDialog value={restProps.value} />
      </Table.Cell>
    );
  }

  const statusColor = row
    ? getQualificationStatusColor(row.status, row.expiryDate, row.issueDate, row.referenceNumber)
    : null;
  const textColor = statusColorStyles[statusColor];
  const textClass = statusTextClasses[statusColor] || '';

  return (
    <Table.Cell
      {...restProps}
      tabIndex={0}
      onFocus={handleFocus}
      onClick={onClick}
      className={`${restProps.className || ''} ${textClass}`.trim()}
      style={{
        ...restProps.style,
        color: textColor || restProps.style?.color,
        border: isInvalid ? '1px solid red' : restProps.style?.border
      }}
      title={isInvalid ? fieldStatus?.error : undefined}
    />
  );
};

const Calendar = ({ ...props }) => {
  const { value, onValueChange, column, autoFocus, onBlur } = props;

  return (
    <td>
      <TextField
        autoFocus={autoFocus}
        onBlur={onBlur}
        type="date"
        inputProps={{
          min: column.name === 'expiryDate' ? format(new Date(), 'yyyy-MM-dd') : undefined,
          max: column.name === 'issueDate' ? format(new Date(), 'yyyy-MM-dd') : undefined
        }}
        onChange={(event) => onValueChange(event.target.value || null)}
        name={column.name}
        value={formatQualificationDate(value, 'yyyy-MM-dd')}
      />
    </td>
  );
};

const formatQualificationDate = (value, pattern) => {
  const date = parseQualificationDate(value);
  return date ? format(date, pattern) : '';
};

const DateFormatter = ({ value, row }) => {
  const color = row
    ? getQualificationStatusColor(row.status, row?.expiryDate, row?.issueDate, row?.referenceNumber)
    : null;
  return (
    <span className={statusTextClasses[color] || ''} style={{ color: statusColorStyles[color] || 'inherit' }}>
      {formatQualificationDate(value, 'dd/MM/yyyy')}
    </span>
  );
};

export const CalendarProvider = (props) => {
  return <DataTypeProvider formatterComponent={DateFormatter} editorComponent={Calendar} {...props} />;
};
